import * as React from 'react';
import UIAsset from '../../atoms/UIAsset/UIAsset';

export type ChoiceStateValue = '' | 'selected' | 'inactive' | 'disabled';

export type ChoiceType = {
	id: string;
	text: string;
	image: string;
	state: ChoiceStateValue;
	deselectable: boolean; // deselectable is used only for visual styling
};

export type ChoiceProps = {
	imagePath?: string;
	choices: ChoiceType[];
	multiple?: Boolean;
	handleChoiceChange: Function;
};

export type ChoiceState = {};

export class Choice extends React.Component<ChoiceProps, ChoiceState> {
	public static defaultProps = {
		imagePath: '/img/svg/',
	};

	constructor(props: ChoiceProps) {
		super(props);

		this.state = {};
	}

	public onChoiceClick = (e) => {
		const choiceId = e.currentTarget.id;
		this.props.handleChoiceChange(choiceId);
	};

	public renderChoice(choice: ChoiceType): JSX.Element {
		const { id, text, image, state, deselectable } = choice;
		const { imagePath } = this.props;
		return (
			<li
				key={id}
				id={id}
				className={`m-choice__item ${state ? 'state-m-choice__item--' + state : ''} ${
					!deselectable && state === 'selected' ? 'state-m-choice__item--not-deselectable' : ''
				}`}
				onClick={this.onChoiceClick}
			>
				<div className="m-choice__bubble">
					<div className="m-choice__back" />
					<UIAsset className="m-choice__image" src={`${imagePath}${image}.svg`} alt="" />
				</div>
				<p className="m-choice__text">{text}</p>
			</li>
		);
	}

	public render() {
		const { choices } = this.props;

		return (
			<div className="m-choice">
				<ol className="m-choice__list">{choices.map((choice) => this.renderChoice(choice))}</ol>
			</div>
		);
	}
}

export default Choice;
